import { render, staticRenderFns } from "./CorralesList.vue?vue&type=template&id=6bdcaa5e"
import script from "./CorralesList.vue?vue&type=script&lang=js"
export * from "./CorralesList.vue?vue&type=script&lang=js"
import style0 from "./CorralesList.vue?vue&type=style&index=0&id=6bdcaa5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports